import { CanActivateFn, Router } from '@angular/router';
import { BookableEvent, bookableEvents } from '../lib/events';
import { inject } from '@angular/core';
import { ApiService } from '../lib/api.service';
import { ProgressService } from '../lib/progress.service';

export const eventSlugExistsGuard: CanActivateFn = (route, state) => {
  const eventSlug = route.paramMap.get('eventSlug') || '';

  const existingEvent = bookableEvents.find(
    (event: BookableEvent) => event.slug === eventSlug,
  );

  const result = !!eventSlug && !!existingEvent;

  if (!result) {
    const router = inject(Router);
    router.navigateByUrl('/');
  } else {
    const progressService = inject(ProgressService)
    const festival = progressService.selectedFestival();
    if(!festival || festival.id !== existingEvent?.apiId) {
      progressService.festivalSelected(existingEvent?.apiId)
    }
  }

  return result;
};
